import { withObservables } from "@nozbe/watermelondb/react";
import { CartItemRenderer } from "./components/CartItemRenderer";
import { CartItemProps } from "./types";
import { getObservables } from "./utils";

const CartItemContainer = ({ product, item }: CartItemProps) => {
  return <CartItemRenderer {...{ product, item }} />;
};

export default withObservables(["item"], getObservables)(CartItemContainer);
